import {
  TURNOVER_LIST_SEARCH, TURNOVER_LIST_SEARCH_FAILURE, TURNOVER_LIST_SEARCH_SUCCESS, TURNOVER_DELETE, TURNOVER_DELETE_FAILURE, TURNOVER_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    turnovertypes: [],
    turnoverListNextPage: null,
    turnoverListCurrentPage: null
  },
  getters: {
    turnoverList: state => {
      return state.turnovertypes
    },
    turnoverListNextPage: state => {
      return state.turnoverListNextPage
    },
    turnoverListCurrentPage: state => {
      return state.turnoverListCurrentPage
    }
  },
  actions: {
    [TURNOVER_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/turnover_types'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(TURNOVER_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(TURNOVER_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [TURNOVER_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('TURNOVER_DELETE:' + params.id)
      var data = params.data
      var url = '/master/turnover_types/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(TURNOVER_DELETE_FAILURE, res.data)
          } else {
            commit(TURNOVER_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [TURNOVER_LIST_SEARCH_FAILURE] (state, params) {
      console.log('TURNOVER_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [TURNOVER_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('TURNOVER_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.turnovertypes = state.turnovertypes.concat(data.data)
        state.turnoverListCurrentPage = data.meta['current-page']
      } else {
        state.turnovertypes = data.data
        state.turnoverListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.turnoverListNextPage = data.links['next']
      } else {
        state.turnoverListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [TURNOVER_DELETE_FAILURE] (state, data) {
      console.log('TURNOVER_DELETE_FAILURE')
    },
    [TURNOVER_DELETE_SUCCESS] (state, data) {
      console.log('TURNOVER_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/turnover-list.js